/* globals CONFIG */
// Initialises the New Relic Browser agent (page load timing, JS errors, SPA
// route changes, AJAX timing). Imported first in `pages/root.js` so it boots
// before the app and captures the initial page load.
//
// Driven entirely by the `newRelic` block in the node-config yml files, so the
// agent only runs in environments where credentials are present (staging /
// production). Locally there is no `newRelic` config, so this is a no-op.
import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';
function initNewRelic() {
    const nr = CONFIG.newRelic;
    if (!(nr === null || nr === void 0 ? void 0 : nr.licenseKey) ||
        !nr.applicationID ||
        !nr.beacon ||
        !nr.agentID ||
        !nr.accountID ||
        !nr.trustKey)
        return undefined;
    return new BrowserAgent({
        info: {
            beacon: nr.beacon,
            errorBeacon: nr.beacon,
            licenseKey: nr.licenseKey,
            applicationID: nr.applicationID,
            sa: 1,
        },
        loader_config: {
            accountID: nr.accountID,
            trustKey: nr.trustKey,
            agentID: nr.agentID,
            licenseKey: nr.licenseKey,
            applicationID: nr.applicationID,
        },
        init: {
            // End-to-end distributed tracing (browser -> pie/edge APM). The agent adds
            // W3C trace context (`traceparent`/`tracestate`) and NR (`newrelic`)
            // headers to XHR/fetch. For cross-origin calls these are only attached to
            // origins in `allowed_origins`, and the target must allow those request
            // headers in its CORS `Access-Control-Allow-Headers` AND have APM DT
            // enabled — see marvelapp_pie (CorsMiddleware + newrelic*.ini). Origins
            // not listed here (e.g. localhost in dev/Cypress) get no DT headers, so
            // local cross-origin calls are unaffected.
            distributed_tracing: {
                enabled: true,
                allowed_origins: [
                    'https://dugout.ballparkhq.com',
                    'https://edge.ballparkhq.com',
                ],
                cors_use_newrelic_header: true,
                cors_use_tracecontext_headers: true,
            },
            privacy: { cookies_enabled: true },
            // Session Replay is bundled in this loader but kept explicitly off — it
            // records full user sessions and needs a consent flow before we enable
            // it. Pinned here so a server-side toggle or package default can't switch
            // it on unexpectedly.
            session_replay: { enabled: false },
            // Don't instrument the agent's own beacon calls.
            ajax: { deny_list: [nr.beacon] },
        },
    });
}
export const browserAgent = initNewRelic();
